import { useCallback, useEffect, useState } from 'react';
import { getToken } from '@/utils/tokenManager';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const authFetch = (path, options = {}) => {
  const token = getToken();
  return fetch(`${BACKEND_URL}/api${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  });
};

export const useContinuityAssets = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const resp = await authFetch('/continuity-assets');
      if (!resp.ok) throw new Error('Failed to load continuity assets');
      const data = await resp.json();
      setItems(data.items || []);
      setError(null);
    } catch (err) {
      setError(err.message || 'Failed to load');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const create = useCallback(async (payload) => {
    const resp = await authFetch('/continuity-assets', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    const data = await resp.json();
    if (!resp.ok) throw new Error(data.detail || 'Could not save');
    await refresh();
    return data;
  }, [refresh]);

  const update = useCallback(async (id, payload) => {
    const resp = await authFetch(`/continuity-assets/${id}`, {
      method: 'PUT',
      body: JSON.stringify(payload),
    });
    const data = await resp.json();
    if (!resp.ok) throw new Error(data.detail || 'Could not update');
    await refresh();
    return data;
  }, [refresh]);

  const remove = useCallback(async (id) => {
    const resp = await authFetch(`/continuity-assets/${id}`, { method: 'DELETE' });
    if (!resp.ok) throw new Error('Could not delete');
    await refresh();
  }, [refresh]);

  return { items, loading, error, refresh, create, update, remove };
};
